"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = function _default(_ref) {
  var hasHeader = _ref.hasHeader;
  return {
    position: 'absolute',
    top: hasHeader ? 4 : 2,
    insetEnd: hasHeader ? 4 : 2,
    color: 'gray.dark',
    borderRadius: 'sm',
    width: 8,
    height: 8,
    _focus: {
      boxShadow: 'outline'
    },
    _hover: {
      bg: 'gray.50'
    }
  };
};